import { computed, type ComputedRef } from "vue";
import { storeToRefs } from "pinia";
import { useUserStore } from "@/stores";
import type { MobiusTenant } from "@/types";

// Returns a non-null reactive reference to the active tenant.
// Intended for components and stores that are only reachable once a tenant is selected (i.e. anything mounted under the tenant-scoped routes).
// If the tenant is unset when this is read, the getter throws, which is preferable to silently propagating a null and crashing later with a less obvious "cannot read property X of null" further down the stack.
export function useCurrentTenant(): ComputedRef<MobiusTenant> {
  const { currentTenant } = storeToRefs(useUserStore());
  return computed(() => {
    if (!currentTenant.value) {
      throw new Error(
        `useCurrentTenant() called without an active tenant.\n
        This composable is only valid in tenant-scoped routes.`
      );
    }
    return currentTenant.value;
  });
}
